(function() {

    var storiesTop = null;
    var storiesBottom = null;
    var stories = [];
    var socialStory = null;
    var prototype =
    '<div class="story" data-story-id="%story_id%">'+
      '<img src="%image_url%" alt="">'+
      '<svg viewbox="0 0 100 100">'+
        '<circle stroke="url(#vertical-gradient)" cx="50" cy="50" r="40"/>'+
      '</svg>'+
    '</div>';

    this.GizzmoStories = function() {

        if($('#storiesTop').length) {
            storiesTop = $('#storiesTop');
        }

        if($('#storiesBottom').length) {
            storiesBottom = $('#storiesBottom');
        }

        getCommentsWithMediaFiles();
    };

    GizzmoStories.prototype.getStory = function(storyId) {
        if(typeof storyId !== "undefined") {
            return stories[storyId];
        }
        return stories;
    };

    GizzmoStories.prototype.getPrototype = function() {
        return prototype;
    };

    function getCommentsWithMediaFiles() {
        var counter = 0;
        var maxStories = 10;
        var minStories = 1;
        var animateHeight = true;
        var ajaxPoolLength = $('.comment-uploads').length;
        var ajaxPool = [];
        if(window.innerWidth >= 768) {
            maxStories = 5;
        }
        if(window.innerWidth < 768) {
            minStories = 3;
        }
        if(document.documentElement.getAttribute("data-is-quickview")) {
            maxStories = 5;
        }

        $('.comment-uploads').each(function(index, element) {
            var name = $(element).parents('.review').find('.name').text() || $(this).data("name");
            var datePublished = $(element).parents('.review').find('.date-published').text() || $(this).data("date-published");
            var id = $(element).data('id');
            $.ajax({
                url: "https://media.wave.si/media.php?get_files&commentId="+$(element).data('id'),
                dataType: "json",
                success: function(data) {
                    var story;
                    var items = [];
                    var itemIndex = 0;
                    var videoThumbCounter = 0;
                    var storyImage = null;
                    var object = null;
                    var devicIndex = 1;
                    if(/(iPad|iPhone|iPod)/g.test(navigator.userAgent)) {
                        devicIndex = 0;
                    }

                    if((typeof data[0].videos !== "undefined" || typeof data[0].images !== "undefined")) {
                        if(typeof data[0].videos !== "undefined") {
                            data[0].videos.forEach(function(el, index) {
                                if(storyImage === null) {
                                    storyImage = data[1][videoThumbCounter];
                                }

                                object = null;
                                object = {
                                    "title": name,
                                    "date": datePublished,
                                    "url": el[devicIndex],
                                    "icon": storyImage
                                };

                                items.push(object);
                                itemIndex++;
                                videoThumbCounter++;
                            });
                        }

                        if(typeof data[0].images !== "undefined") {
                            data[0].images.forEach(function(el, index) {
                                var thumbUrl = el.split("/");
                                thumbUrl.splice(thumbUrl.length-1, 0, "image_thumbnails");
                                thumbUrl = thumbUrl.join("/");

                                if(storyImage === null) {
                                    storyImage = thumbUrl;
                                }

                                object = null;
                                object = {
                                    "title": name,
                                    "date": datePublished,
                                    "url": el,
                                    "icon": storyImage
                                };

                                items.push(object);
                                itemIndex++;
                            });
                        }

                        if(counter < maxStories) {
                            if(storiesTop !== null) {
                                storiesTop.append(prototype
                                    .replace("%image_url%", items[0].icon)
                                    .replace("%story_id%", id)
                                );
                            }
                            if(storiesBottom !== null) {
                                storiesBottom.append(prototype
                                    .replace("%image_url%", items[0].icon)
                                    .replace("%story_id%", id)
                                );
                            }
                        }
                        counter++;
                        stories[parseInt(id)] = items;
                    }
                },
                complete: function() {
                    ajaxPool.push(1);
                    if(storiesTop !== null) {
                        if(ajaxPool.length == ajaxPoolLength) {
                            if(storiesTop.children().length >= minStories) {
                                if(window.innerWidth < 768) {
                                    if(animateHeight) {
                                        animateHeight = false;
                                        $('#storiesTop').addClass('expand');
                                    }
                                }
                            } else {
                                $('#storiesTop').remove();
                            }
                        }
                    }
                    setTimeout(function() {
                        window.top.postMessage("resizeQuickViewIframe", window.location.origin);
                    }, 1000);
                }
            });
        });
    }
}());

var gizzmoStories = new GizzmoStories();
$('body').on('click', '.gizzmo-stories .story, .product__feautered-reviews .main-image', function(e) {
    socialStory = new Story({
         playlist: gizzmoStories.getStory($(this).data('storyId'))
    });
    socialStory.launch();
});
